import SignInForm from '@/components/Forms/SignInForm';
import Header from '@/components/Header';
import {type Tokens, useUserContext} from '@/components/Providers/UserContext';
import {Container, Stack} from '@mui/material';
import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

type Props = {
    setUser: (user: Tokens) => void;
};

const SignIn = ({setUser}: Props): ReactElement => {
    const {user} = useUserContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    return (
        <Stack
            direction='column'
            sx={{
                backgroundColor: '#631d79',
                minHeight: '100vh',
            }}
        >
            <Header />
            <Container sx={{mt: '125px'}}>
                <SignInForm setUser={setUser} />
            </Container>
        </Stack>
    );
};

export default SignIn;
